const doc = [({"en":({"js":({"routes":({"admin":({"schools":({"audits":({"what_happened_to_school":"What happened to the school", "what_the_school_did":"What the school did"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;